import { UNKNOWN, VALIDATION_ERROR } from 'reporting-data/constants/errorTypes';
import { createExceptionFromErrorType } from 'reporting-data/lib/createExceptionFromErrorType';
function errorIsValidationError(error) {
  return error.responseJSON && error.responseJSON.category === VALIDATION_ERROR;
}
export default function handleRequestError(error) {
  const exceptionParameters = errorIsValidationError(error) ? [error.responseJSON.subCategory, error.responseJSON.context, error] : [UNKNOWN, null, error];
  createExceptionFromErrorType(...exceptionParameters);
}